module.exports = __webpack_public_path__ + "img/signs12.145d2b5e.jpg";